<template>
  <v-container class="fill-height">
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4 xl2 offset-xl5>
        <v-card class="mt-5 pa-5">
          <v-layout class="text-center mb-5">
            <v-flex xs12>
              <h1>New Password</h1>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-form>
              <v-text-field v-if="this.successMessage == null" v-model="user.password" label="Password" type="password"></v-text-field>
              <v-text-field v-if="this.successMessage == null" v-model="user.confirm" label="Confirm Password" type="password"></v-text-field>
              <div v-if="this.resetError != null" class="text-center error--text mt-3 mb-5 error-message">{{resetError}}</div>
              <div v-if="this.successMessage != null" class="text-center success--text mt-3 mb-5 success-message">{{successMessage}}</div>
              <v-btn class="my-2" block large @click="resetPassword(user)" color="success">Submit</v-btn>
              <v-btn class="my-2" block large @click="backToLogin" color="info">Return to Login</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'password-reset',
  created () {
    this.accountClear()
    this.setParams()
  },

  data: () => ({
    user: {
      password: null,
      confirm: null,
      id: null,
      token: null,
      email: null
    }
  }),
  methods: {
    ...mapActions({
      resetPassword: 'account/resetPassword',
      accountClear: 'account/clearAccount'
    }),

    setParams () {
      this.user.token = this.$route.params.token
      this.user.email = this.$route.params.email
    },
    backToLogin () {
      this.accountClear()
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters({
      resetError: 'account/error',
      successMessage: 'account/success'
    })
  }
}
</script>

<style scoped>
  .error-message {
    height: 20px;
    font-weight: bold;
  }
</style>
